module.exports = __webpack_public_path__ + "img/logo copy.006967f2.svg";